import actions from './actions';

const initialState = {
  isSearching: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
};

export default function relayReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CREATE_RELAY_ITEM:
    case actions.CREATE_RELAY_ITEM_API:
      return {
        ...state,
        isCreating: true,
      };
    case actions.CREATE_RELAY_ITEM_ENDED:
    case actions.CREATE_RELAY_ITEM_API_ENDED:
      return {
        ...state,
        isCreating: false,
      };
    case actions.SEARCH_RELAY_ITEMS:
    case actions.SEARCH_RELAY_ITEM_APIS:
    case actions.FIND_RELAY_ITEM_API:
      return {
        ...state,
        isSearching: true,
      };
    case actions.SEARCH_RELAY_ITEMS_ENDED:
    case actions.SEARCH_RELAY_ITEM_APIS_ENDED:
    case actions.FIND_RELAY_ITEM_API_ENDED:
      return {
        ...state,
        isSearching: false,
      };
    case actions.UPDATE_RELAY_ITEM:
    case actions.UPDATE_RELAY_ITEM_API:
      return {
        ...state,
        isUpdating: true,
      };
    case actions.UPDATE_RELAY_ITEM_ENDED:
    case actions.UPDATE_RELAY_ITEM_API_ENDED:
      return {
        ...state,
        isUpdating: false,
      };
    case actions.DELETE_RELAY_ITEMS:
    case actions.DELETE_RELAY_ITEM_APIS:
      return {
        ...state,
        isDeleting: true,
      };
    case actions.DELETE_RELAY_ITEMS_ENDED:
    case actions.DELETE_RELAY_ITEM_APIS_ENDED:
      return {
        ...state,
        isDeleting: false,
      };
    default:
      return state;
  }
}
